import { Button } from '@/app/common/components/button/Button'
import Label from '@/app/common/components/Label'
import { FilterIcon } from '@/app/common/icons/general'
import { SystemCatalogCategory } from '@/queries/system_catalog/system_catalog.schema'
import { Checkbox } from '@/shad/ui/checkbox'
import { Popover, PopoverContent, PopoverTrigger } from '@/shad/ui/popover'
import { ScrollArea } from '@/shad/ui/scroll-area'
import { useState } from 'react'

interface Props {
  categories: SystemCatalogCategory[]
  onFilterChange: (selectedCategories: number[]) => void
  selectedCategoryIds: number[]
}

function CategoriesFilter(props: Props) {
  const { categories, onFilterChange, selectedCategoryIds } = props
  const [open, setOpen] = useState(false)

  const handleCategoryToggle = (categoryId: number) => {
    const newSelectedCategories = selectedCategoryIds.includes(categoryId)
      ? selectedCategoryIds.filter((id) => id !== categoryId)
      : [...selectedCategoryIds, categoryId]

    onFilterChange(newSelectedCategories)
  }

  const clearFilters = () => {
    onFilterChange([])
  }

  const numberOfCategoriesSelected = selectedCategoryIds.length

  const pluralize = numberOfCategoriesSelected > 1 ? 's' : ''

  return (
    <div className="relative">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="flex items-center gap-2"
          >
            <FilterIcon />
            {numberOfCategoriesSelected > 0 ? (
              `${numberOfCategoriesSelected} Active Filter${pluralize}`
            ) : (
              <>Categories</>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-64 p-0" align="start">
          <div className="flex items-center justify-between p-3 border-b">
            <h4 className="font-medium">Filter by Category</h4>
            {selectedCategoryIds.length > 0 && (
              <Button
                variant="outline"
                size="xs"
                onClick={clearFilters}
                className="h-8 px-2 text-xs"
              >
                Clear all
              </Button>
            )}
          </div>
          <ScrollArea className="h-80">
            <div className="p-3 space-y-3">
              {categories.map((category) => {
                const id = `category-${category.id}`

                return (
                  <div key={id} className="flex items-center space-x-2">
                    <Checkbox
                      name={category.name}
                      id={id}
                      checked={selectedCategoryIds.includes(category.id)}
                      onCheckedChange={() => handleCategoryToggle(category.id)}
                    />
                    <div className="truncate max-w-full">
                      <Label weight={'normal'} htmlFor={id}>
                        {category.name}
                      </Label>
                    </div>
                  </div>
                )
              })}
            </div>
          </ScrollArea>
        </PopoverContent>
      </Popover>
    </div>
  )
}

export default CategoriesFilter
